import { PageNavigationItem } from '../../../components/Navigation/PageNavigation/PageNavigation';

export const SUB_LINK_IDS = {
  MAP: 'rg-map',
  GENERAL_INFO: 'rg-generalInfo',
  TOP_SPECIES: 'rg-topSpecies',
  FISHING_REPORTS: 'rg-fishingReports',
  FISHING_REGULATIONS: 'rg-regulations',
  STATE_RECORDS: 'rg-stateRecords',
  FISHING_SPOTS: 'rg-fishingSpots',
  BIGGEST_CATCHES: 'rg-biggestCatches',
  BLOG: 'rg-blog',
  FAQ: 'rg-faq',
  EXPLORE_MORE: 'rg-explore-more',
};

export function getSubNavLinks({
  hasBlog,
  hasSpeciesGroups,
  hasFishingSpots,
  hasCatches,
  hasRecords,
  hasRegulations,
  hasGeneralInfo,
  hasFaqData,
  hasExploreMore,
}: {
  hasBlog?: boolean;
  hasSpeciesGroups?: boolean;
  hasFishingSpots?: boolean;
  hasCatches?: boolean;
  hasRecords?: boolean;
  hasRegulations?: boolean;
  hasGeneralInfo?: boolean;
  hasFaqData?: boolean;
  hasExploreMore?: boolean;
}): PageNavigationItem[] {
  return [
    { id: SUB_LINK_IDS.MAP, label: 'Map', orderMobile: 1, orderTablet: 1 },
    ...(hasFishingSpots
      ? [
          {
            id: SUB_LINK_IDS.FISHING_SPOTS,
            label: 'Fishing spots',
            orderMobile: 2,
            orderTablet: 2,
            orderDesktop: 4,
          },
        ]
      : []),
    ...(hasGeneralInfo
      ? [
          {
            id: SUB_LINK_IDS.GENERAL_INFO,
            label: 'General info',
            orderMobile: 3,
            orderTablet: 3,
            orderDesktop: 2,
          },
        ]
      : []),

    ...(hasSpeciesGroups
      ? [
          {
            id: SUB_LINK_IDS.TOP_SPECIES,
            label: 'Top species',
            orderMobile: 4,
            orderTablet: 4,
            orderDesktop: 3,
          },
        ]
      : []),
    { id: SUB_LINK_IDS.BIGGEST_CATCHES, label: 'Biggest catches', orderMobile: 5, orderTablet: 5 },
    ...(hasRecords
      ? [
          {
            id: SUB_LINK_IDS.STATE_RECORDS,
            label: 'State records',
            orderMobile: 6,
            orderTablet: 6,
          },
        ]
      : []),
    ...(hasCatches
      ? [
          {
            id: SUB_LINK_IDS.FISHING_REPORTS,
            label: 'Fishing reports',
            orderMobile: 7,
            orderTablet: 7,
          },
        ]
      : []),
    ...(hasRegulations
      ? [
          {
            id: SUB_LINK_IDS.FISHING_REGULATIONS,
            label: 'Regulations',
            orderMobile: 8,
            orderTablet: 8,
          },
        ]
      : []),
    ...(hasBlog ? [{ id: SUB_LINK_IDS.BLOG, label: 'Blog', orderMobile: 9, orderTablet: 9 }] : []),
    ...(hasFaqData
      ? [{ id: SUB_LINK_IDS.FAQ, label: 'FAQ', orderMobile: 10, orderTablet: 10 }]
      : []),
    ...(hasExploreMore
      ? [{ id: SUB_LINK_IDS.EXPLORE_MORE, label: 'Explore more', orderMobile: 11, orderTablet: 11 }]
      : []),
  ];
}
